<template>
    <div class="model-detail">
        <el-card class="box-card model-desc" shadow="always">
            <div class="topSetting">
                 <el-button icon="el-icon-setting" type="primary" @click="handleRelationship()">关联关系</el-button>
                 <el-button icon="el-icon-view" type="primary" @click="handleFilterField()">报表显示字段</el-button>           
            </div>
        </el-card>

        <div class="model-content">
            <div class="content-left">
                <DynamicTable
                    :tableColumns="tableColumns"
                    :tableData="pageData"
                    :isLoading="tableLoading"
                    :isShowCheckbox="false"
                    :isSortable="true"
                    @changePage="queryFormData">
                </DynamicTable>
            </div>

            <el-dialog
                title="批量导入"
                append-to-body
                :visible.sync="isShowExcelData">
                <ExcelDataImport ref="excelInstance"  @importComplete="handleSearch" />
                <!-- <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowNewProcess = false">取 消</el-button>
                    <el-button type="primary" @click="handleSaveProcess">确 定</el-button>
                </span> -->
            </el-dialog>

            <el-dialog
                title="设置关联关系"
                :visible.sync="isShowRelationship"
                width="70%"
                append-to-body
                >
                <ReferenceField  ref="referenceField"  :models="modelSources" :referenceFields="referenceFields"  />
            </el-dialog>

            <el-dialog
                title="选择显示字段"
                append-to-body
                :visible.sync="isShowFilterField">
                <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions"  :selectViewFields="selectViewFields" :isGroup="true" />
            </el-dialog>

            <el-dialog
                title="设置查询条件"
                append-to-body
                :visible.sync="isShowSearchConditon">
                <SearchCondition  ref="searchConditon" :conditionFields="conditionFields"  @chooseSearchConditon="chooseSearchConditon"  />
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import ReferenceField from '@/components/ReferenceField';
    import SelectMultiple from '@/components/SelectMultiple';
    import SearchCondition from '@/components/SearchCondition';
    import { cloneDeep } from 'lodash';
    import { getFormConfigFromStore } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        mixins: [ mixinsNav ],
        components: {
            // ModelDetail,
            // ExcelDataImport,
            ReferenceField,
            SelectMultiple,
            SearchCondition
        },
        data () {
            return {
                tableLoading: false,
                idStr: '',
                printStr: '',
                isShowModelDetail: false,
                isShowExcelData: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                    modelId: '',
                    name: '',
                    // referenceFields:[],//关联关系
                    // selectedTableColumns: [],
                    searchCondition: []
                },
                tableColumns: [],
                pageData: [],
                active: false, // 是否显示数据编辑侧滑弹窗
                formInfo: {},
                downloadUrl: '',
                isShowFilterField: false,
                sourceOptions: [],
                oldSelectedModel: {},
                isRefreshSel: false,
                isRefreshCondition: true,
                isShowSearchConditon: false,
                // conditionFields:[],
                isShowRelationship: false
                // selectViewFields:[]
            };
        },
        props: {
            modelData: {
                type: Object
            },
            modelSources: {
                type: Array
                // default: () => { return []; }
            },
            referenceFields: {
                type: Array
                // default: () => { return []; }
            },
            selectedTableColumns: {
                type: Array
                // default: () => { return []; }
            },
            conditionFields: {
                type: Array
                // default: () => { return []; }
            },
            selectViewFields: {
                type: Array
                // default: () => { return []; }
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            _initPage () {
                // this.$refs.referenceField._initPage();
                if (this.selectedTableColumns.length > 0) {
                    this.tableColumns = this.selectedTableColumns;
                }
            },
            handleBusinessApplication () {
                this.navMyBusiness(this.modelData.appId, this.modelData.modelId);
            },
            handleRelationship () {
                // console.log(this.modelSources);
                this.isShowRelationship = true;
            },
            async chooseReferenceFields () {
                this.isShowRelationship = false;
                this.referenceFields = this.$refs.referenceField.getReferenceFields();
                // console.log(this.referenceFields);
                this.searchParams.referenceFields = this.referenceFields;
                // this.queryFormData(this.page);
            },
            resetReferenceFields () {
                // this.referenceFields.length=0;
                this.referenceFields = [];
                // this.referenceFields=cloneDeep(this.tableColumns);
            },
            handleFilterCondition () {
                this.isShowSearchConditon = true;
                if (this.isRefreshCondition) {
                    this.conditionFields = cloneDeep(this.tableColumns);
                    this.isRefreshCondition = false;
                }
            },
            async handleFilterField () {
                this.isShowFilterField = true;
                // this.selectedTableColumns=['Beijing','Chengdu'];
                this.sourceOptions = [];
                // console.log(this.modelSources);
                this.modelSources.forEach(async (item) => {
                    let { fieldsList } = await getFormConfigFromStore(item.formId);
                    this.sourceOptions.push({label: item.label, options: fieldsList});
                });
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 0);
            },
            async chooseViewFields () {
                this.isShowFilterField = false;
                this.tableColumns = [];
                let tempFields = this.$refs.selectMultiple.getSelectViewFields();
                // console.log(tempFields);
                if (tempFields.length > 0) {
                    // this.resetViewFields();
                    tempFields.forEach((item) => {
                        this.tableColumns.push({prop: item.id, label: item.name});
                    });
                }
                this.isRefreshCondition = true;
                // this.selectViewFields=tempFields;
                // console.log(this.tableColumns);
                this.$emit('setTableColumns', this.tableColumns);
            },
            resetViewFields () {
                this.tableColumns = [];
                // this.$emit('setTableColumns', this.tableColumns);
            },
            resetSearchConditon () {
                this.conditionFields.length = 0;
                this.conditionFields = cloneDeep(this.tableColumns);
            },
            async chooseSearchConditon () {
                this.isShowSearchConditon = false;
                let searchCondition = this.$refs.searchConditon.getSearchCondition();
                // console.log(searchCondition);
                this.searchParams.searchCondition = searchCondition;
                this.queryFormData(this.page);
            },
            queryFormData ({currentPage}) {
                this.page.currentPage = currentPage;
                this.renderFormList(this.selectedModel);
            },
            switchAddFormData () {
                this.$emit('switchMode', 2);
            },
            handleSearch () {
                this.isShowExcelData = false;
                this.queryFormData(this.page);
            },
            download (url) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            }
        }
    };
</script>

<style lang="less">
    .model-detail {
        width: 100%;
        height: 100%;
        overflow-y: auto;

        .el-collapse-item__wrap {
            padding: 0 20px;
        }

        .el-collapse {
            width: 100%;
        }

        // .el-form {
        //     width: 500px;
        // }

        .model-btns {
            height: 80px;
            padding: 0 10px 0 0;
        }

        .model-desc {
            margin: 20px 15px;
            .el-card__body {
                height: 15px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .topSetting {
                    margin-top: -10px;
                }
            }
        }

        .model-content {
            flex: 1;
            margin: 0 15px;

            display: flex;
            flex-direction: row;
        }

        .content-left {
            width: 100%;
            margin: 0 15px 0 0;
        }
        .comments {
            width: 300px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CsCustomReportConfig/CsCustomReportConfig.vue